import { render, staticRenderFns } from "./AccountsAndFees.vue?vue&type=template&id=b146de0a&"
import script from "./AccountsAndFees.vue?vue&type=script&lang=js&"
export * from "./AccountsAndFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports